var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.productClass},[_c('features-navigation'),_vm._v(" "),(_vm.isBiggerThanTabletLandscape)?_c('base-sidebar'):_vm._e(),_vm._v(" "),_c('features-content'),_vm._v(" "),(!_vm.isBiggerThanTabletLandscape)?_c('membership-footer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }